export const logUser = state => {
	// console.log('log user in');
}

export const showModal = (state) => {
	state.modal = true;
}

export const hideModal = (state) => {
	state.globalModalState = false;
	state.globalModalParams = {};
	setTimeout(function () {
		state.globalModalTitle = '';
		state.globalModalComponent = '';
		state.globalModalState = '';
		state.globalModalParams = '';
	}, 100)
}

export const changeUsername = (state,payload) => {
	state.username = payload;
}

export const setSessionId = (state,payload) => {
	state.sessionId = payload;
}

export const setObjAuthorize = (state,payload) => {
	state.objAuthorize = JSON.stringify(payload);
}

export const setJwtAuth = (state,payload) => {
	state.jwtAuth = payload;
}

export const setJwtAuthExpired = (state) => {
	state.jwtAuth = '';
	state.objAuthorize = '';
}

export const setSnack = (state,payload) => {
	state.globalSnackDisplay = '';
	setTimeout(function(){
		state.globalSnackDisplay = payload.display;
		state.globalSnackColor = payload.color;
		state.globalSnackMessage = payload.message;
	}, 1000)
}

export const setModal = (state,payload) => {
	//state.globalModalState = '';
	state.globalModalParams = {};
	setTimeout(function(){
		state.globalModalTitle = payload.details.title;
		state.globalModalComponent = payload.details.component;
		state.globalModalState = payload.details.mstate;
		if( payload.details.params !== undefined ) {
			state.globalModalParams = payload.details.params;
		}
	}, 100)
}

export const setGlobalModalTitle = (state,payload) => {
  setTimeout(function(){
    state.globalModalTitle = payload;
  }, 100)
}

export const setLoginDetails = (state,payload) => {
	state.objAuthorize = JSON.stringify(payload.objAuth);
	state.jwtAuth = payload.jwtToken;
	state.spineToken = payload.spineToken;
	state.globalSnackDisplay = '';
	setTimeout(function(){
		state.globalSnackDisplay = '';
		state.globalSnackColor = '';
		state.globalSnackMessage = '';
	}, 100)
}

export const setAppOnline = (state) => {
	var appOnline = navigator.onLine;
	if( appOnline !== true ) {
		state.appOnline = false;
		//router.replace('/network');
	} else {
		state.appOnline = true;
	}
}

export const fncSetSpinePriceList = (state, payload, rootState) => {
	state.spinePriceList = payload;
}

export const toggleDrawer = (state, payload) => {
	if (payload != undefined) {
		state.sideProps = payload;
	} else {
		state.sideProps = !state.sideProps;
	}
}

export const setIsLoading = (state, payload) => {
	state.isLoading = payload;
}

export const fncUpdateObjAuth = (state, payload) => {
	var objAuth = '';
	if (state.objAuthorize != '') {
		objAuth = JSON.parse(state.objAuthorize);
		objAuth.manu_user_alias = payload.manu_user_alias;
		objAuth.manu_user_clr = payload.manu_user_clr;
		objAuth.customer_user_alias = payload.customer_user_alias;
		objAuth.customer_user_clr = payload.customer_user_clr;
		objAuth.public_user_alias = payload.public_user_alias;
		objAuth.public_user_clr = payload.public_user_clr;
		objAuth.specifier_user_alias = payload.specifier_user_alias;
		objAuth.specifier_user_clr = payload.specifier_user_clr;
		state.objAuthorize = JSON.stringify(objAuth);
	}
}

export const fncQuotePagination = (state, payload) => {
  state.quotePagination = payload;
}

export const setManualInstallations = (state, payload) => {
  var objAuth = '';
  if (state.objAuthorize != '') {
    objAuth = JSON.parse(state.objAuthorize);
    objAuth.manual_installations = payload;
    state.objAuthorize = JSON.stringify(objAuth);
  }
}

export const setInstallations = (state, payload) => {
  var objAuth = '';
  if (state.objAuthorize != '') {
    objAuth = JSON.parse(state.objAuthorize);
    objAuth.installations = payload;
    state.objAuthorize = JSON.stringify(objAuth);
  }
}

export const fncSetTemplates = (state, payload, rootState) => {

  var objAuth = JSON.parse(state.objAuthorize);

  objAuth.po_template = payload.po_template;
  objAuth.so_template = payload.so_template;
  objAuth.quote_template = payload.quote_template;

  state.objAuthorize = JSON.stringify(objAuth);

}
